import { render, staticRenderFns } from "./WardImportRequestList.vue?vue&type=template&id=4292263e&"
import script from "./WardImportRequestList.vue?vue&type=script&lang=js&"
export * from "./WardImportRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports